/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { EsitiOperazioneDTO } from '../model/esiti-operazione-dto';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GenericResponseDTO } from '../model/generic-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelServizioMensaRendicontazioneDTO } from '../model/paged-model-servizio-mensa-rendicontazione-dto';
// @ts-ignore
import { PagedModelServizioMensaRicaricaDTO } from '../model/paged-model-servizio-mensa-ricarica-dto';
// @ts-ignore
import { PagedModelServizioMensaStudenteDTO } from '../model/paged-model-servizio-mensa-studente-dto';
// @ts-ignore
import { PagedModelServizioMensaStudenteReportDTO } from '../model/paged-model-servizio-mensa-studente-report-dto';
// @ts-ignore
import { ServizioMensaAddPatchRicaricaForm } from '../model/servizio-mensa-add-patch-ricarica-form';
// @ts-ignore
import { ServizioMensaDifformitaPastiDTO } from '../model/servizio-mensa-difformita-pasti-dto';
// @ts-ignore
import { ServizioMensaEsenzioneForm } from '../model/servizio-mensa-esenzione-form';
// @ts-ignore
import { ServizioMensaEventoAggiornamentoDTO } from '../model/servizio-mensa-evento-aggiornamento-dto';
// @ts-ignore
import { ServizioMensaEventoCalendarioDTO } from '../model/servizio-mensa-evento-calendario-dto';
// @ts-ignore
import { ServizioMensaEventoCalendarioForm } from '../model/servizio-mensa-evento-calendario-form';
// @ts-ignore
import { ServizioMensaFratelloDTO } from '../model/servizio-mensa-fratello-dto';
// @ts-ignore
import { ServizioMensaGeneraDovutoForm } from '../model/servizio-mensa-genera-dovuto-form';
// @ts-ignore
import { ServizioMensaMenuExtraForm } from '../model/servizio-mensa-menu-extra-form';
// @ts-ignore
import { ServizioMensaMultiricaricaForm } from '../model/servizio-mensa-multiricarica-form';
// @ts-ignore
import { ServizioMensaRendicontazioneDTO } from '../model/servizio-mensa-rendicontazione-dto';
// @ts-ignore
import { ServizioMensaRicaricaDTO } from '../model/servizio-mensa-ricarica-dto';
// @ts-ignore
import { ServizioMensaRicaricaDetailDTO } from '../model/servizio-mensa-ricarica-detail-dto';
// @ts-ignore
import { ServizioMensaRicaricheTotaliDTO } from '../model/servizio-mensa-ricariche-totali-dto';
// @ts-ignore
import { ServizioMensaSaldiInizialiForm } from '../model/servizio-mensa-saldi-iniziali-form';
// @ts-ignore
import { ServizioMensaSaldoInizialeForm } from '../model/servizio-mensa-saldo-iniziale-form';
// @ts-ignore
import { ServizioMensaSospensioneForm } from '../model/servizio-mensa-sospensione-form';
// @ts-ignore
import { ServizioMensaStudenteAggiornamentoDTO } from '../model/servizio-mensa-studente-aggiornamento-dto';
// @ts-ignore
import { ServizioMensaStudenteAnagraficaDTO } from '../model/servizio-mensa-studente-anagrafica-dto';
// @ts-ignore
import { ServizioMensaStudenteDTO } from '../model/servizio-mensa-studente-dto';
// @ts-ignore
import { ServizioMensaStudenteListFilter } from '../model/servizio-mensa-studente-list-filter';
// @ts-ignore
import { ServizioMensaStudentePortafogliDTO } from '../model/servizio-mensa-studente-portafogli-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    ServizioMensaStudentiServiceInterface,
    AddServizioMensaStudenteEventoCalendarioRequestParams,
    AggiornaStatoServizioMensaStudenteRicaricaRequestParams,
    CancellaServizioMensaStudenteDovutoRequestParams,
    CreateServizioMensaMultiricaricheRequestParams,
    CreateServizioMensaStudenteRicaricaRequestParams,
    GeneraServizioMensaStudenteDovutoRequestParams,
    GetServizioMensaStudenteRequestParams,
    GetServizioMensaStudenteFratelliRequestParams,
    GetServizioMensaStudenteGenitoreAnagraficaRequestParams,
    GetServizioMensaStudentePortafogliRequestParams,
    GetServizioMensaStudenteRicaricaRequestParams,
    GetServizioMensaStudenteRicaricheTotaliRequestParams,
    ListServizioMensaStudenteAggiornamentiRequestParams,
    ListServizioMensaStudenteEventiCalendarioRequestParams,
    ListServizioMensaStudenteEventoCalendarioAggiornamentiRequestParams,
    ListServizioMensaStudenteRendicontazioniRequestParams,
    ListServizioMensaStudenteRicaricheRequestParams,
    ListServizioMensaStudentiRequestParams,
    ListServizioMensaStudentiPerReportRequestParams,
    PatchServizioMensaStudenteEsenzioneRequestParams,
    PatchServizioMensaStudenteRicaricaRequestParams,
    PatchServizioMensaStudenteSospensioneRequestParams,
    RemoveServizioMensaStudenteEventoCalendarioRequestParams,
    RicalcolaServizioMensaPortafogliServizioRequestParams,
    RicalcolaServizioMensaStudentePortafogliRequestParams,
    RicalcolaServizioMensaStudenteRendicontazioneMensileRequestParams,
    ScaricaAvvisoServizioMensaOperatoreRequestParams,
    ScaricaRicevutaServizioMensaOperatoreRequestParams,
    SetServizioMensaStudenteMenuExtraRequestParams,
    SetServizioMensaStudenteSaldoInizialeRequestParams,
    SetServizioMensaStudentiSaldiInizialiRequestParams,
    ToggleServizioMensaStudenteRendicontazioneDisabilitazioneRequestParams,
    VerificaDifformitaPastiServizioMensaRequestParams
} from './servizio-mensa-studenti.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ServizioMensaStudentiService extends BaseService implements ServizioMensaStudentiServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Aggiunge uno o più eventi calendario a uno studente.
     * Crea un evento ASSENZA/PASTA_IN_BIANCO per ogni giorno-mensa del range [data_inizio..data_fine] (esclude le chiusure settimanali). forza_evento bypassa il gate data-passata/oltre-cutoff (onorato per l\&#39;operatore). Su ASSENZA-passata ricalcola il portafogli (derivato). Audience OP_SCUOLA/ADMIN/SUPERADMIN e OP_COMUNE col permesso GESTIONE_CALENDARIO_MENSA. Studente di altro servizio → 404.
     * @endpoint post /api/v1/servizi/mensa/studenti/{id_studente}/evento-calendario
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public addServizioMensaStudenteEventoCalendario(requestParameters: AddServizioMensaStudenteEventoCalendarioRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaEventoCalendarioDTO>>;
    public addServizioMensaStudenteEventoCalendario(requestParameters: AddServizioMensaStudenteEventoCalendarioRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaEventoCalendarioDTO>>>;
    public addServizioMensaStudenteEventoCalendario(requestParameters: AddServizioMensaStudenteEventoCalendarioRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaEventoCalendarioDTO>>>;
    public addServizioMensaStudenteEventoCalendario(requestParameters: AddServizioMensaStudenteEventoCalendarioRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling addServizioMensaStudenteEventoCalendario.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling addServizioMensaStudenteEventoCalendario.');
        }
        const servizioMensaEventoCalendarioForm = requestParameters?.servizioMensaEventoCalendarioForm;
        if (servizioMensaEventoCalendarioForm === null || servizioMensaEventoCalendarioForm === undefined) {
            throw new Error('Required parameter servizioMensaEventoCalendarioForm was null or undefined when calling addServizioMensaStudenteEventoCalendario.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/evento-calendario`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaEventoCalendarioDTO>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaEventoCalendarioForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Aggiorna da PagoPA lo stato di una singola ricarica di uno studente.
     * Backoffice (ADMIN/SUPERADMIN/OP_COMUNE). Interroga PagoPA sulla sola posizione e ne riporta lo stato; su transizione a PAGATA ricalcola il portafogli e valuta la rimozione della sospensione. Nessuna accettazione con riserva. Ritorna il dettaglio con lo storico, che registra ogni verifica. Ricarica senza IUV o annullata → 400; errore del provider → 500.
     * @endpoint post /api/v1/servizi/mensa/studenti/{id_studente}/ricariche/{id_ricarica}/aggiorna-stato
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public aggiornaStatoServizioMensaStudenteRicarica(requestParameters: AggiornaStatoServizioMensaStudenteRicaricaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRicaricaDetailDTO>;
    public aggiornaStatoServizioMensaStudenteRicarica(requestParameters: AggiornaStatoServizioMensaStudenteRicaricaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRicaricaDetailDTO>>;
    public aggiornaStatoServizioMensaStudenteRicarica(requestParameters: AggiornaStatoServizioMensaStudenteRicaricaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRicaricaDetailDTO>>;
    public aggiornaStatoServizioMensaStudenteRicarica(requestParameters: AggiornaStatoServizioMensaStudenteRicaricaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling aggiornaStatoServizioMensaStudenteRicarica.');
        }
        const idRicarica = requestParameters?.idRicarica;
        if (idRicarica === null || idRicarica === undefined) {
            throw new Error('Required parameter idRicarica was null or undefined when calling aggiornaStatoServizioMensaStudenteRicarica.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling aggiornaStatoServizioMensaStudenteRicarica.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricariche/${this.configuration.encodeParam({name: "idRicarica", value: idRicarica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/aggiorna-stato`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRicaricaDetailDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Cancella un dovuto PagoPA di uno studente.
     * Verbo POST (allineato al matcher legacy). Gate isRicaricaCancellabile; invoca PagoPA, stato CANCELLATA, scollega la rendicontazione. Ricarica di altro studente → 404.
     * @endpoint post /api/v1/servizi/mensa/studenti/{id_studente}/cancella-pagamento
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public cancellaServizioMensaStudenteDovuto(requestParameters: CancellaServizioMensaStudenteDovutoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRicaricaDTO>;
    public cancellaServizioMensaStudenteDovuto(requestParameters: CancellaServizioMensaStudenteDovutoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRicaricaDTO>>;
    public cancellaServizioMensaStudenteDovuto(requestParameters: CancellaServizioMensaStudenteDovutoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRicaricaDTO>>;
    public cancellaServizioMensaStudenteDovuto(requestParameters: CancellaServizioMensaStudenteDovutoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling cancellaServizioMensaStudenteDovuto.');
        }
        const idRicarica = requestParameters?.idRicarica;
        if (idRicarica === null || idRicarica === undefined) {
            throw new Error('Required parameter idRicarica was null or undefined when calling cancellaServizioMensaStudenteDovuto.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling cancellaServizioMensaStudenteDovuto.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'id_ricarica',
            <any>idRicarica,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cancella-pagamento`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRicaricaDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea più ricariche in bulk (multiricarica operatore).
     * Itera la creazione singola per ciascuna riga; ogni studente è scopato al servizio header (anti-IDOR). Studente di altro servizio nella lista → 404 sull\&#39;intera richiesta. NON esposto al cittadino.
     * @endpoint post /api/v1/servizi/mensa/studenti/ricariche
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createServizioMensaMultiricariche(requestParameters: CreateServizioMensaMultiricaricheRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaRicaricaDTO>>;
    public createServizioMensaMultiricariche(requestParameters: CreateServizioMensaMultiricaricheRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaRicaricaDTO>>>;
    public createServizioMensaMultiricariche(requestParameters: CreateServizioMensaMultiricaricheRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaRicaricaDTO>>>;
    public createServizioMensaMultiricariche(requestParameters: CreateServizioMensaMultiricaricheRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling createServizioMensaMultiricariche.');
        }
        const servizioMensaMultiricaricaForm = requestParameters?.servizioMensaMultiricaricaForm;
        if (servizioMensaMultiricaricaForm === null || servizioMensaMultiricaricaForm === undefined) {
            throw new Error('Required parameter servizioMensaMultiricaricaForm was null or undefined when calling createServizioMensaMultiricariche.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/ricariche`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaRicaricaDTO>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaMultiricaricaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea una ricarica per uno studente (PagoPA o manuale).
     * Gate sul tipoPagamento del servizio: ramo PagoPA crea il dovuto (IN_ATTESA_PAGAMENTO); ramo MANUALE (ADMIN/OP_COMUNE) inserisce una PAGATA + ricalcolo multi-anno. Studente esente → errore; valore &lt; 0 → errore; valore &gt; importo massimo (servizio) → errore.
     * @endpoint post /api/v1/servizi/mensa/studenti/{id_studente}/ricarica
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createServizioMensaStudenteRicarica(requestParameters: CreateServizioMensaStudenteRicaricaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRicaricaDTO>;
    public createServizioMensaStudenteRicarica(requestParameters: CreateServizioMensaStudenteRicaricaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRicaricaDTO>>;
    public createServizioMensaStudenteRicarica(requestParameters: CreateServizioMensaStudenteRicaricaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRicaricaDTO>>;
    public createServizioMensaStudenteRicarica(requestParameters: CreateServizioMensaStudenteRicaricaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling createServizioMensaStudenteRicarica.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling createServizioMensaStudenteRicarica.');
        }
        const servizioMensaAddPatchRicaricaForm = requestParameters?.servizioMensaAddPatchRicaricaForm;
        if (servizioMensaAddPatchRicaricaForm === null || servizioMensaAddPatchRicaricaForm === undefined) {
            throw new Error('Required parameter servizioMensaAddPatchRicaricaForm was null or undefined when calling createServizioMensaStudenteRicarica.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricarica`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRicaricaDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaAddPatchRicaricaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Genera un dovuto PagoPA da una rendicontazione.
     * Solo servizi PAGO_PA_RENDICONTAZIONE*; risolve la rendicontazione (ownership), richiede importo negativo, niente dovuto valido esistente, crea ricarica + dovuto e la collega alla rendicontazione. Studente di altro servizio → 404.
     * @endpoint post /api/v1/servizi/mensa/studenti/{id_studente}/genera-dovuto
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public generaServizioMensaStudenteDovuto(requestParameters: GeneraServizioMensaStudenteDovutoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRicaricaDTO>;
    public generaServizioMensaStudenteDovuto(requestParameters: GeneraServizioMensaStudenteDovutoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRicaricaDTO>>;
    public generaServizioMensaStudenteDovuto(requestParameters: GeneraServizioMensaStudenteDovutoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRicaricaDTO>>;
    public generaServizioMensaStudenteDovuto(requestParameters: GeneraServizioMensaStudenteDovutoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling generaServizioMensaStudenteDovuto.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling generaServizioMensaStudenteDovuto.');
        }
        const servizioMensaGeneraDovutoForm = requestParameters?.servizioMensaGeneraDovutoForm;
        if (servizioMensaGeneraDovutoForm === null || servizioMensaGeneraDovutoForm === undefined) {
            throw new Error('Required parameter servizioMensaGeneraDovutoForm was null or undefined when calling generaServizioMensaStudenteDovuto.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/genera-dovuto`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRicaricaDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaGeneraDovutoForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di uno studente del servizio mensa (studente + stato).
     * Ritorna lo studente del servizio con identità/scolastico/dieta dal reader e i campi operativi mensa dalle colonne native. Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioMensaStudente(requestParameters: GetServizioMensaStudenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaStudenteDTO>;
    public getServizioMensaStudente(requestParameters: GetServizioMensaStudenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaStudenteDTO>>;
    public getServizioMensaStudente(requestParameters: GetServizioMensaStudenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaStudenteDTO>>;
    public getServizioMensaStudente(requestParameters: GetServizioMensaStudenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling getServizioMensaStudente.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getServizioMensaStudente.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaStudenteDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Fratelli di uno studente del servizio mensa.
     * Ritorna gli altri studenti dello stesso genitore (richiedente) nel servizio, non sospesi, escluso lo studente stesso. Studente di altro servizio → 404. Per un OP_SCUOLA la coorte NON e\&#39; ridotta (serve al conteggio dello sconto multifiglio) ma i fratelli iscritti a scuole non assegnate sono restituiti in forma ridotta: visibile&#x3D;false e nessun dato identificativo.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/fratelli
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioMensaStudenteFratelli(requestParameters: GetServizioMensaStudenteFratelliRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaFratelloDTO>>;
    public getServizioMensaStudenteFratelli(requestParameters: GetServizioMensaStudenteFratelliRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaFratelloDTO>>>;
    public getServizioMensaStudenteFratelli(requestParameters: GetServizioMensaStudenteFratelliRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaFratelloDTO>>>;
    public getServizioMensaStudenteFratelli(requestParameters: GetServizioMensaStudenteFratelliRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling getServizioMensaStudenteFratelli.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getServizioMensaStudenteFratelli.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/fratelli`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaFratelloDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Anagrafica del genitore di uno studente del servizio mensa.
     * Ritorna l\&#39;anagrafica del genitore (richiedente) dello studente, letta via FK origine + reader. Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/genitore-anagrafica
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioMensaStudenteGenitoreAnagrafica(requestParameters: GetServizioMensaStudenteGenitoreAnagraficaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaStudenteAnagraficaDTO>;
    public getServizioMensaStudenteGenitoreAnagrafica(requestParameters: GetServizioMensaStudenteGenitoreAnagraficaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaStudenteAnagraficaDTO>>;
    public getServizioMensaStudenteGenitoreAnagrafica(requestParameters: GetServizioMensaStudenteGenitoreAnagraficaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaStudenteAnagraficaDTO>>;
    public getServizioMensaStudenteGenitoreAnagrafica(requestParameters: GetServizioMensaStudenteGenitoreAnagraficaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling getServizioMensaStudenteGenitoreAnagrafica.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getServizioMensaStudenteGenitoreAnagrafica.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/genitore-anagrafica`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaStudenteAnagraficaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Portafogli di uno studente del servizio mensa.
     * Ritorna il portafogli (residuo, pasti residui, costo pasto/contributo, saldo iniziale, pasti usufruiti) dello studente. Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/portafogli
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioMensaStudentePortafogli(requestParameters: GetServizioMensaStudentePortafogliRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaStudentePortafogliDTO>;
    public getServizioMensaStudentePortafogli(requestParameters: GetServizioMensaStudentePortafogliRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaStudentePortafogliDTO>>;
    public getServizioMensaStudentePortafogli(requestParameters: GetServizioMensaStudentePortafogliRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaStudentePortafogliDTO>>;
    public getServizioMensaStudentePortafogli(requestParameters: GetServizioMensaStudentePortafogliRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling getServizioMensaStudentePortafogli.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getServizioMensaStudentePortafogli.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/portafogli`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaStudentePortafogliDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di una ricarica di uno studente (con aggiornamenti).
     * Ritorna la ricarica con la lista ordinata degli aggiornamenti (audit). Anti-IDOR cross-studente: ricarica di altro studente → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/ricariche/{id_ricarica}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioMensaStudenteRicarica(requestParameters: GetServizioMensaStudenteRicaricaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRicaricaDetailDTO>;
    public getServizioMensaStudenteRicarica(requestParameters: GetServizioMensaStudenteRicaricaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRicaricaDetailDTO>>;
    public getServizioMensaStudenteRicarica(requestParameters: GetServizioMensaStudenteRicaricaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRicaricaDetailDTO>>;
    public getServizioMensaStudenteRicarica(requestParameters: GetServizioMensaStudenteRicaricaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling getServizioMensaStudenteRicarica.');
        }
        const idRicarica = requestParameters?.idRicarica;
        if (idRicarica === null || idRicarica === undefined) {
            throw new Error('Required parameter idRicarica was null or undefined when calling getServizioMensaStudenteRicarica.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getServizioMensaStudenteRicarica.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricariche/${this.configuration.encodeParam({name: "idRicarica", value: idRicarica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRicaricaDetailDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Totale dei pagamenti di uno studente per anno solare.
     * Somma del valore delle ricariche PAGATA con min(data, dataPagamento) nell\&#39;anno richiesto (D-18.17). Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/ricariche/totali
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioMensaStudenteRicaricheTotali(requestParameters: GetServizioMensaStudenteRicaricheTotaliRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRicaricheTotaliDTO>;
    public getServizioMensaStudenteRicaricheTotali(requestParameters: GetServizioMensaStudenteRicaricheTotaliRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRicaricheTotaliDTO>>;
    public getServizioMensaStudenteRicaricheTotali(requestParameters: GetServizioMensaStudenteRicaricheTotaliRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRicaricheTotaliDTO>>;
    public getServizioMensaStudenteRicaricheTotali(requestParameters: GetServizioMensaStudenteRicaricheTotaliRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling getServizioMensaStudenteRicaricheTotali.');
        }
        const anno = requestParameters?.anno;
        if (anno === null || anno === undefined) {
            throw new Error('Required parameter anno was null or undefined when calling getServizioMensaStudenteRicaricheTotali.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getServizioMensaStudenteRicaricheTotali.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'anno',
            <any>anno,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricariche/totali`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRicaricheTotaliDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Storico degli aggiornamenti di stato di uno studente.
     * Ritorna lo storico ordinato degli aggiornamenti di stato dello studente (attore tipizzato, commento, lista operazioni). Sola lettura, backoffice stretto (ADMIN/SUPERADMIN/OP_COMUNE — OP_SCUOLA/OP_CENTRO_COTTURA esclusi). Studente di altro servizio → 404; nessun aggiornamento → 200 [].
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/aggiornamenti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listServizioMensaStudenteAggiornamenti(requestParameters: ListServizioMensaStudenteAggiornamentiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaStudenteAggiornamentoDTO>>;
    public listServizioMensaStudenteAggiornamenti(requestParameters: ListServizioMensaStudenteAggiornamentiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaStudenteAggiornamentoDTO>>>;
    public listServizioMensaStudenteAggiornamenti(requestParameters: ListServizioMensaStudenteAggiornamentiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaStudenteAggiornamentoDTO>>>;
    public listServizioMensaStudenteAggiornamenti(requestParameters: ListServizioMensaStudenteAggiornamentiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling listServizioMensaStudenteAggiornamenti.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listServizioMensaStudenteAggiornamenti.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/aggiornamenti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaStudenteAggiornamentoDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista degli eventi calendario personali di uno studente.
     * Eventi personali dello studente ordinati per data, incluse le CANCELLATE (audience operatore). Niente chiusure scolastiche (D-18.24). Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/evento-calendario
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listServizioMensaStudenteEventiCalendario(requestParameters: ListServizioMensaStudenteEventiCalendarioRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaEventoCalendarioDTO>>;
    public listServizioMensaStudenteEventiCalendario(requestParameters: ListServizioMensaStudenteEventiCalendarioRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaEventoCalendarioDTO>>>;
    public listServizioMensaStudenteEventiCalendario(requestParameters: ListServizioMensaStudenteEventiCalendarioRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaEventoCalendarioDTO>>>;
    public listServizioMensaStudenteEventiCalendario(requestParameters: ListServizioMensaStudenteEventiCalendarioRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling listServizioMensaStudenteEventiCalendario.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listServizioMensaStudenteEventiCalendario.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/evento-calendario`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaEventoCalendarioDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Storico audit di un evento calendario di uno studente.
     * Ritorna lo storico ordinato degli aggiornamenti audit del singolo evento calendario (attore tipizzato, operazione). Solo operatore (audience servizio piena); NON esposto al cittadino. Anti-IDOR chain evento→studente: evento di altro studente → 404. Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/evento-calendario/{id_evento}/aggiornamenti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listServizioMensaStudenteEventoCalendarioAggiornamenti(requestParameters: ListServizioMensaStudenteEventoCalendarioAggiornamentiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaEventoAggiornamentoDTO>>;
    public listServizioMensaStudenteEventoCalendarioAggiornamenti(requestParameters: ListServizioMensaStudenteEventoCalendarioAggiornamentiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaEventoAggiornamentoDTO>>>;
    public listServizioMensaStudenteEventoCalendarioAggiornamenti(requestParameters: ListServizioMensaStudenteEventoCalendarioAggiornamentiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaEventoAggiornamentoDTO>>>;
    public listServizioMensaStudenteEventoCalendarioAggiornamenti(requestParameters: ListServizioMensaStudenteEventoCalendarioAggiornamentiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling listServizioMensaStudenteEventoCalendarioAggiornamenti.');
        }
        const idEvento = requestParameters?.idEvento;
        if (idEvento === null || idEvento === undefined) {
            throw new Error('Required parameter idEvento was null or undefined when calling listServizioMensaStudenteEventoCalendarioAggiornamenti.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listServizioMensaStudenteEventoCalendarioAggiornamenti.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/evento-calendario/${this.configuration.encodeParam({name: "idEvento", value: idEvento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/aggiornamenti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaEventoAggiornamentoDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata delle rendicontazioni mensili di uno studente.
     * Ritorna le rendicontazioni dello studente, incluse le disabilitate (audience operatore). Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/rendicontazioni
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listServizioMensaStudenteRendicontazioni(requestParameters: ListServizioMensaStudenteRendicontazioniRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelServizioMensaRendicontazioneDTO>;
    public listServizioMensaStudenteRendicontazioni(requestParameters: ListServizioMensaStudenteRendicontazioniRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelServizioMensaRendicontazioneDTO>>;
    public listServizioMensaStudenteRendicontazioni(requestParameters: ListServizioMensaStudenteRendicontazioniRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelServizioMensaRendicontazioneDTO>>;
    public listServizioMensaStudenteRendicontazioni(requestParameters: ListServizioMensaStudenteRendicontazioniRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling listServizioMensaStudenteRendicontazioni.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listServizioMensaStudenteRendicontazioni.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listServizioMensaStudenteRendicontazioni.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazioni`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelServizioMensaRendicontazioneDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata delle ricariche di uno studente.
     * Ritorna le ricariche dello studente (Page, ordine dataPagamento DESC, data DESC). DTO leggero senza aggiornamenti. Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/ricariche
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listServizioMensaStudenteRicariche(requestParameters: ListServizioMensaStudenteRicaricheRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelServizioMensaRicaricaDTO>;
    public listServizioMensaStudenteRicariche(requestParameters: ListServizioMensaStudenteRicaricheRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelServizioMensaRicaricaDTO>>;
    public listServizioMensaStudenteRicariche(requestParameters: ListServizioMensaStudenteRicaricheRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelServizioMensaRicaricaDTO>>;
    public listServizioMensaStudenteRicariche(requestParameters: ListServizioMensaStudenteRicaricheRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling listServizioMensaStudenteRicariche.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listServizioMensaStudenteRicariche.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listServizioMensaStudenteRicariche.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricariche`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelServizioMensaRicaricaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista filtrata degli studenti del servizio mensa.
     * Ritorna gli studenti del servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id, filtrabili per nominativo, codice pratica, scuola/plesso, classe, sezione, pasti residui (range), esente, sospeso. Audience operatore.
     * @endpoint post /api/v1/servizi/mensa/studenti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listServizioMensaStudenti(requestParameters: ListServizioMensaStudentiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelServizioMensaStudenteDTO>;
    public listServizioMensaStudenti(requestParameters: ListServizioMensaStudentiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelServizioMensaStudenteDTO>>;
    public listServizioMensaStudenti(requestParameters: ListServizioMensaStudentiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelServizioMensaStudenteDTO>>;
    public listServizioMensaStudenti(requestParameters: ListServizioMensaStudentiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listServizioMensaStudenti.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listServizioMensaStudenti.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listServizioMensaStudenti.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelServizioMensaStudenteDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista degli studenti del servizio mensa per report.
     * Ritorna gli studenti del servizio con i relativi portafogli, per il report.
     * @endpoint get /api/v1/servizi/mensa/studenti/report
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listServizioMensaStudentiPerReport(requestParameters: ListServizioMensaStudentiPerReportRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelServizioMensaStudenteReportDTO>;
    public listServizioMensaStudentiPerReport(requestParameters: ListServizioMensaStudentiPerReportRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelServizioMensaStudenteReportDTO>>;
    public listServizioMensaStudentiPerReport(requestParameters: ListServizioMensaStudentiPerReportRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelServizioMensaStudenteReportDTO>>;
    public listServizioMensaStudentiPerReport(requestParameters: ListServizioMensaStudentiPerReportRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listServizioMensaStudentiPerReport.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listServizioMensaStudentiPerReport.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/report`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelServizioMensaStudenteReportDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Toggle esenzione di uno studente con ricalcolo multi-anno.
     * Set isEsente/motivoEsenzione con tracking delta; se ricalcola_portafogli&#x3D;true e il valore di esenzione cambia, delega il ricalcolo al motore multi-anno. Studente di altro servizio → 404.
     * @endpoint patch /api/v1/servizi/mensa/studenti/{id_studente}/esenzione
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public patchServizioMensaStudenteEsenzione(requestParameters: PatchServizioMensaStudenteEsenzioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaStudenteDTO>;
    public patchServizioMensaStudenteEsenzione(requestParameters: PatchServizioMensaStudenteEsenzioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaStudenteDTO>>;
    public patchServizioMensaStudenteEsenzione(requestParameters: PatchServizioMensaStudenteEsenzioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaStudenteDTO>>;
    public patchServizioMensaStudenteEsenzione(requestParameters: PatchServizioMensaStudenteEsenzioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling patchServizioMensaStudenteEsenzione.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling patchServizioMensaStudenteEsenzione.');
        }
        const servizioMensaEsenzioneForm = requestParameters?.servizioMensaEsenzioneForm;
        if (servizioMensaEsenzioneForm === null || servizioMensaEsenzioneForm === undefined) {
            throw new Error('Required parameter servizioMensaEsenzioneForm was null or undefined when calling patchServizioMensaStudenteEsenzione.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/esenzione`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaStudenteDTO>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaEsenzioneForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifica una ricarica manuale di uno studente.
     * Solo ricariche di pagamento manuale; aggiorna bollettino/dataPagamento/valore/note (diff) + audit; su delta valore → ricalcolo multi-anno. Ricarica di altro studente → 404.
     * @endpoint patch /api/v1/servizi/mensa/studenti/{id_studente}/ricarica/{id_ricarica}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public patchServizioMensaStudenteRicarica(requestParameters: PatchServizioMensaStudenteRicaricaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRicaricaDTO>;
    public patchServizioMensaStudenteRicarica(requestParameters: PatchServizioMensaStudenteRicaricaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRicaricaDTO>>;
    public patchServizioMensaStudenteRicarica(requestParameters: PatchServizioMensaStudenteRicaricaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRicaricaDTO>>;
    public patchServizioMensaStudenteRicarica(requestParameters: PatchServizioMensaStudenteRicaricaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling patchServizioMensaStudenteRicarica.');
        }
        const idRicarica = requestParameters?.idRicarica;
        if (idRicarica === null || idRicarica === undefined) {
            throw new Error('Required parameter idRicarica was null or undefined when calling patchServizioMensaStudenteRicarica.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling patchServizioMensaStudenteRicarica.');
        }
        const servizioMensaAddPatchRicaricaForm = requestParameters?.servizioMensaAddPatchRicaricaForm;
        if (servizioMensaAddPatchRicaricaForm === null || servizioMensaAddPatchRicaricaForm === undefined) {
            throw new Error('Required parameter servizioMensaAddPatchRicaricaForm was null or undefined when calling patchServizioMensaStudenteRicarica.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricarica/${this.configuration.encodeParam({name: "idRicarica", value: idRicarica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRicaricaDTO>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaAddPatchRicaricaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Toggle sospensione di uno studente.
     * Idempotente (nessun cambio se già nello stato richiesto); delega al chokepoint pagamenti. Studente di altro servizio → 404.
     * @endpoint patch /api/v1/servizi/mensa/studenti/{id_studente}/sospensione
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public patchServizioMensaStudenteSospensione(requestParameters: PatchServizioMensaStudenteSospensioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaStudenteDTO>;
    public patchServizioMensaStudenteSospensione(requestParameters: PatchServizioMensaStudenteSospensioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaStudenteDTO>>;
    public patchServizioMensaStudenteSospensione(requestParameters: PatchServizioMensaStudenteSospensioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaStudenteDTO>>;
    public patchServizioMensaStudenteSospensione(requestParameters: PatchServizioMensaStudenteSospensioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling patchServizioMensaStudenteSospensione.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling patchServizioMensaStudenteSospensione.');
        }
        const servizioMensaSospensioneForm = requestParameters?.servizioMensaSospensioneForm;
        if (servizioMensaSospensioneForm === null || servizioMensaSospensioneForm === undefined) {
            throw new Error('Required parameter servizioMensaSospensioneForm was null or undefined when calling patchServizioMensaStudenteSospensione.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/sospensione`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaStudenteDTO>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaSospensioneForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rimuove (cancella logicamente) un evento calendario di uno studente.
     * Imposta stato&#x3D;CANCELLATO + audit; forzaEvento bypassa il gate data-passata/oltre-cutoff. Su ASSENZA-passata ricalcola il portafogli (derivato). Audience OP_SCUOLA/ADMIN/SUPERADMIN e OP_COMUNE col permesso GESTIONE_CALENDARIO_MENSA. Evento di altro studente → 404.
     * @endpoint delete /api/v1/servizi/mensa/studenti/{id_studente}/evento-calendario/{id_evento}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public removeServizioMensaStudenteEventoCalendario(requestParameters: RemoveServizioMensaStudenteEventoCalendarioRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaEventoCalendarioDTO>;
    public removeServizioMensaStudenteEventoCalendario(requestParameters: RemoveServizioMensaStudenteEventoCalendarioRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaEventoCalendarioDTO>>;
    public removeServizioMensaStudenteEventoCalendario(requestParameters: RemoveServizioMensaStudenteEventoCalendarioRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaEventoCalendarioDTO>>;
    public removeServizioMensaStudenteEventoCalendario(requestParameters: RemoveServizioMensaStudenteEventoCalendarioRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling removeServizioMensaStudenteEventoCalendario.');
        }
        const idEvento = requestParameters?.idEvento;
        if (idEvento === null || idEvento === undefined) {
            throw new Error('Required parameter idEvento was null or undefined when calling removeServizioMensaStudenteEventoCalendario.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling removeServizioMensaStudenteEventoCalendario.');
        }
        const forzaEvento = requestParameters?.forzaEvento;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'forzaEvento',
            <any>forzaEvento,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/evento-calendario/${this.configuration.encodeParam({name: "idEvento", value: idEvento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaEventoCalendarioDTO>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ricalcolo del portafogli di tutti gli studenti del servizio.
     * Ridefinizione per-servizio del legacy ricalcola-portafogli-comune: scope header-tenant. Ritorna gli eventuali errori per-studente.
     * @endpoint put /api/v1/servizi/mensa/studenti/ricalcola-portafogli-servizio
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public ricalcolaServizioMensaPortafogliServizio(requestParameters: RicalcolaServizioMensaPortafogliServizioRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EsitiOperazioneDTO>;
    public ricalcolaServizioMensaPortafogliServizio(requestParameters: RicalcolaServizioMensaPortafogliServizioRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EsitiOperazioneDTO>>;
    public ricalcolaServizioMensaPortafogliServizio(requestParameters: RicalcolaServizioMensaPortafogliServizioRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EsitiOperazioneDTO>>;
    public ricalcolaServizioMensaPortafogliServizio(requestParameters: RicalcolaServizioMensaPortafogliServizioRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling ricalcolaServizioMensaPortafogliServizio.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/ricalcola-portafogli-servizio`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<EsitiOperazioneDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ricalcolo del portafogli di un singolo studente.
     * Delega al motore multi-anno; audit per-studente. Studente di altro servizio → 404.
     * @endpoint put /api/v1/servizi/mensa/studenti/{id_studente}/ricalcola-portafogli
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public ricalcolaServizioMensaStudentePortafogli(requestParameters: RicalcolaServizioMensaStudentePortafogliRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaStudenteDTO>;
    public ricalcolaServizioMensaStudentePortafogli(requestParameters: RicalcolaServizioMensaStudentePortafogliRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaStudenteDTO>>;
    public ricalcolaServizioMensaStudentePortafogli(requestParameters: RicalcolaServizioMensaStudentePortafogliRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaStudenteDTO>>;
    public ricalcolaServizioMensaStudentePortafogli(requestParameters: RicalcolaServizioMensaStudentePortafogliRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling ricalcolaServizioMensaStudentePortafogli.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling ricalcolaServizioMensaStudentePortafogli.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricalcola-portafogli`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaStudenteDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ricalcolo della rendicontazione mensile di uno studente.
     * Delega al motore multi-anno. numero_mese in [1..12]; dataFinale opzionale (YYYY-MM-DD). Rendicontazione disabilitata → skip; dovuto già generato → errore diagnostico. Studente di altro servizio → 404.
     * @endpoint put /api/v1/servizi/mensa/studenti/{id_studente}/ricalcola-rendicontazione-mensile/{numero_mese}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public ricalcolaServizioMensaStudenteRendicontazioneMensile(requestParameters: RicalcolaServizioMensaStudenteRendicontazioneMensileRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GenericResponseDTO>;
    public ricalcolaServizioMensaStudenteRendicontazioneMensile(requestParameters: RicalcolaServizioMensaStudenteRendicontazioneMensileRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GenericResponseDTO>>;
    public ricalcolaServizioMensaStudenteRendicontazioneMensile(requestParameters: RicalcolaServizioMensaStudenteRendicontazioneMensileRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GenericResponseDTO>>;
    public ricalcolaServizioMensaStudenteRendicontazioneMensile(requestParameters: RicalcolaServizioMensaStudenteRendicontazioneMensileRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling ricalcolaServizioMensaStudenteRendicontazioneMensile.');
        }
        const numeroMese = requestParameters?.numeroMese;
        if (numeroMese === null || numeroMese === undefined) {
            throw new Error('Required parameter numeroMese was null or undefined when calling ricalcolaServizioMensaStudenteRendicontazioneMensile.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling ricalcolaServizioMensaStudenteRendicontazioneMensile.');
        }
        const dataFinale = requestParameters?.dataFinale;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'dataFinale',
            <any>dataFinale,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricalcola-rendicontazione-mensile/${this.configuration.encodeParam({name: "numeroMese", value: numeroMese, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GenericResponseDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Scarica l\&#39;avviso di pagamento (PDF) di una ricarica di uno studente.
     * Lettura (audience servizio piena, catch-all studenti). Ritorna il PDF dell\&#39;avviso PagoPA come allegato (application/pdf, Content-Disposition: attachment). Anti-IDOR studente (header-tenant) + ricarica (cross-studente). Avviso senza numeroAvviso → 400.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/ricariche/{id_ricarica}/avviso
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public scaricaAvvisoServizioMensaOperatore(requestParameters: ScaricaAvvisoServizioMensaOperatoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public scaricaAvvisoServizioMensaOperatore(requestParameters: ScaricaAvvisoServizioMensaOperatoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public scaricaAvvisoServizioMensaOperatore(requestParameters: ScaricaAvvisoServizioMensaOperatoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public scaricaAvvisoServizioMensaOperatore(requestParameters: ScaricaAvvisoServizioMensaOperatoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling scaricaAvvisoServizioMensaOperatore.');
        }
        const idRicarica = requestParameters?.idRicarica;
        if (idRicarica === null || idRicarica === undefined) {
            throw new Error('Required parameter idRicarica was null or undefined when calling scaricaAvvisoServizioMensaOperatore.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling scaricaAvvisoServizioMensaOperatore.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricariche/${this.configuration.encodeParam({name: "idRicarica", value: idRicarica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/avviso`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Scarica la ricevuta di pagamento (PDF) di una ricarica di uno studente.
     * Lettura (audience servizio piena, catch-all studenti). Ritorna il PDF della ricevuta PagoPA come allegato (application/pdf, Content-Disposition: attachment). Anti-IDOR studente (header-tenant) + ricarica (cross-studente). Ricevuta senza IUV → 400.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/ricariche/{id_ricarica}/ricevuta
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public scaricaRicevutaServizioMensaOperatore(requestParameters: ScaricaRicevutaServizioMensaOperatoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public scaricaRicevutaServizioMensaOperatore(requestParameters: ScaricaRicevutaServizioMensaOperatoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public scaricaRicevutaServizioMensaOperatore(requestParameters: ScaricaRicevutaServizioMensaOperatoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public scaricaRicevutaServizioMensaOperatore(requestParameters: ScaricaRicevutaServizioMensaOperatoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling scaricaRicevutaServizioMensaOperatore.');
        }
        const idRicarica = requestParameters?.idRicarica;
        if (idRicarica === null || idRicarica === undefined) {
            throw new Error('Required parameter idRicarica was null or undefined when calling scaricaRicevutaServizioMensaOperatore.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling scaricaRicevutaServizioMensaOperatore.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricariche/${this.configuration.encodeParam({name: "idRicarica", value: idRicarica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricevuta`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Associa/rimuove il menu extra di uno studente.
     * Audience OP_SCUOLA e OP_COMUNE (+ ADMIN/SUPERADMIN), NON OP_CENTRO_COTTURA. Identificativo valorizzato → menu EXTRA del servizio; ORDINARIO non associabile; null/vuoto → azzera. Studente di altro servizio → 404.
     * @endpoint put /api/v1/servizi/mensa/studenti/{id_studente}/menu-extra
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public setServizioMensaStudenteMenuExtra(requestParameters: SetServizioMensaStudenteMenuExtraRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaStudenteDTO>;
    public setServizioMensaStudenteMenuExtra(requestParameters: SetServizioMensaStudenteMenuExtraRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaStudenteDTO>>;
    public setServizioMensaStudenteMenuExtra(requestParameters: SetServizioMensaStudenteMenuExtraRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaStudenteDTO>>;
    public setServizioMensaStudenteMenuExtra(requestParameters: SetServizioMensaStudenteMenuExtraRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling setServizioMensaStudenteMenuExtra.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling setServizioMensaStudenteMenuExtra.');
        }
        const servizioMensaMenuExtraForm = requestParameters?.servizioMensaMenuExtraForm;
        if (servizioMensaMenuExtraForm === null || servizioMensaMenuExtraForm === undefined) {
            throw new Error('Required parameter servizioMensaMenuExtraForm was null or undefined when calling setServizioMensaStudenteMenuExtra.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/menu-extra`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaStudenteDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaMenuExtraForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set/edit del saldo iniziale del portafogli di uno studente.
     * Aggiusta il residuo in modo incrementale (delta sul saldo iniziale precedente) e imposta il nuovo saldo iniziale. Studente di altro servizio → 404.
     * @endpoint put /api/v1/servizi/mensa/studenti/{id_studente}/saldo-iniziale
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public setServizioMensaStudenteSaldoIniziale(requestParameters: SetServizioMensaStudenteSaldoInizialeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaStudenteDTO>;
    public setServizioMensaStudenteSaldoIniziale(requestParameters: SetServizioMensaStudenteSaldoInizialeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaStudenteDTO>>;
    public setServizioMensaStudenteSaldoIniziale(requestParameters: SetServizioMensaStudenteSaldoInizialeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaStudenteDTO>>;
    public setServizioMensaStudenteSaldoIniziale(requestParameters: SetServizioMensaStudenteSaldoInizialeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling setServizioMensaStudenteSaldoIniziale.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling setServizioMensaStudenteSaldoIniziale.');
        }
        const servizioMensaSaldoInizialeForm = requestParameters?.servizioMensaSaldoInizialeForm;
        if (servizioMensaSaldoInizialeForm === null || servizioMensaSaldoInizialeForm === undefined) {
            throw new Error('Required parameter servizioMensaSaldoInizialeForm was null or undefined when calling setServizioMensaStudenteSaldoIniziale.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/saldo-iniziale`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaStudenteDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaSaldoInizialeForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set/edit bulk del saldo iniziale per più studenti.
     * Stessa formula del set singolo, per riga, con scope per-servizio (studenti di altri servizi ignorati). Ritorna i messaggi degli studenti saltati.
     * @endpoint put /api/v1/servizi/mensa/studenti/saldi-iniziali
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public setServizioMensaStudentiSaldiIniziali(requestParameters: SetServizioMensaStudentiSaldiInizialiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EsitiOperazioneDTO>;
    public setServizioMensaStudentiSaldiIniziali(requestParameters: SetServizioMensaStudentiSaldiInizialiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EsitiOperazioneDTO>>;
    public setServizioMensaStudentiSaldiIniziali(requestParameters: SetServizioMensaStudentiSaldiInizialiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EsitiOperazioneDTO>>;
    public setServizioMensaStudentiSaldiIniziali(requestParameters: SetServizioMensaStudentiSaldiInizialiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling setServizioMensaStudentiSaldiIniziali.');
        }
        const servizioMensaSaldiInizialiForm = requestParameters?.servizioMensaSaldiInizialiForm;
        if (servizioMensaSaldiInizialiForm === null || servizioMensaSaldiInizialiForm === undefined) {
            throw new Error('Required parameter servizioMensaSaldiInizialiForm was null or undefined when calling setServizioMensaStudentiSaldiIniziali.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/saldi-iniziali`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<EsitiOperazioneDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaSaldiInizialiForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Toggle disabilitazione di una rendicontazione di uno studente.
     * ADMIN/SUPERADMIN-only (NON OP_COMUNE, asimmetria legacy). Inverte disabilitata: la disabilitazione è rifiutata se la ricarica collegata è in stato diverso da ERRORE/CANCELLATA (dovuto attivo); la riabilitazione è sempre consentita, nessun ricalcolo. Rendicontazione di altro studente → 404.
     * @endpoint put /api/v1/servizi/mensa/studenti/{id_studente}/rendicontazione/{id_rendicontazione}/toggle-disabilitazione
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public toggleServizioMensaStudenteRendicontazioneDisabilitazione(requestParameters: ToggleServizioMensaStudenteRendicontazioneDisabilitazioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRendicontazioneDTO>;
    public toggleServizioMensaStudenteRendicontazioneDisabilitazione(requestParameters: ToggleServizioMensaStudenteRendicontazioneDisabilitazioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRendicontazioneDTO>>;
    public toggleServizioMensaStudenteRendicontazioneDisabilitazione(requestParameters: ToggleServizioMensaStudenteRendicontazioneDisabilitazioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRendicontazioneDTO>>;
    public toggleServizioMensaStudenteRendicontazioneDisabilitazione(requestParameters: ToggleServizioMensaStudenteRendicontazioneDisabilitazioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling toggleServizioMensaStudenteRendicontazioneDisabilitazione.');
        }
        const idRendicontazione = requestParameters?.idRendicontazione;
        if (idRendicontazione === null || idRendicontazione === undefined) {
            throw new Error('Required parameter idRendicontazione was null or undefined when calling toggleServizioMensaStudenteRendicontazioneDisabilitazione.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling toggleServizioMensaStudenteRendicontazioneDisabilitazione.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazione/${this.configuration.encodeParam({name: "idRendicontazione", value: idRendicontazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/toggle-disabilitazione`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRendicontazioneDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verifica difformità pasti del servizio mensa.
     * Confronta i pasti calcolati dal calendario reference con quelli salvati sul portafogli, per gli studenti del servizio. Diagnostico ADMIN/SUPERADMIN.
     * @endpoint get /api/v1/servizi/mensa/studenti/verifica-difformita-pasti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public verificaDifformitaPastiServizioMensa(requestParameters: VerificaDifformitaPastiServizioMensaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaDifformitaPastiDTO>;
    public verificaDifformitaPastiServizioMensa(requestParameters: VerificaDifformitaPastiServizioMensaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaDifformitaPastiDTO>>;
    public verificaDifformitaPastiServizioMensa(requestParameters: VerificaDifformitaPastiServizioMensaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaDifformitaPastiDTO>>;
    public verificaDifformitaPastiServizioMensa(requestParameters: VerificaDifformitaPastiServizioMensaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling verificaDifformitaPastiServizioMensa.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/studenti/verifica-difformita-pasti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaDifformitaPastiDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
